import { useDashboardFilters } from '@/contexts/DashboardStateContext';
import { useDashboardLocation } from '@/hooks/useDashboardLocation';
import {
  IWorkingLocationPresenceType,
  WL_PRESENCE_OFFICE
} from '@gettactic/api';
import { AgendaDay } from './AgendaDay';
import { AgendaDay as AgendaDayType } from '@gettactic/api';
import { parseApiDate } from '@gettactic/helpers';
import { useReserve } from '@webV2/providers/ReserveProvider/context';

enum ResourceType {
  Desk = 'desk',
  Parking = 'parking',
  Room = 'room'
}

export const AgendaWeek = ({
  locationData
}: {
  locationData: ReturnType<typeof useDashboardLocation>;
}) => {
  const {
    scheduleMeData,
    updateWorkingLocation,
    getLocationForDate,
    isLocationLoading,
    availableDays,
    authenticatedUser
  } = locationData;

  const { openReserveModal } = useReserve();
  const days = Object.keys(scheduleMeData.data?.days || {});

  const { selectedEvent, setSelectedEvent } = useDashboardFilters();
  
  return (
    // -mt-[7px] keep first card aligned with first icon
    <div className="-mt-[7px] flex flex-col gap-6">
      {days?.slice(0, (availableDays || []).length).map((date, index) => {
        // We have to cast here because there is an agenda for each day
        const todaysAgenda = scheduleMeData.data?.agenda[date] as AgendaDayType;
        const location = todaysAgenda?.location;
        const officeId = todaysAgenda?.office_id;

        // Get the effective location data (actual or optimistic)
        const effectiveDay = getLocationForDate(
          date,
          (scheduleMeData.data?.agenda[date]) || null
        );

        const isLoading = isLocationLoading(date);

        return (
          <AgendaDay
            key={`dash_schedule_${date}_${location}`}
            office_id={officeId}
            date={date}
            location={
              location !== WL_PRESENCE_OFFICE
                ? (location as IWorkingLocationPresenceType)
                : null
            }
            workingLocationId={officeId ?? undefined}
            schedule={scheduleMeData.data?.agenda[date]?.schedules ?? []}
            onSelectItemChange={setSelectedEvent}
            selectedEvent={selectedEvent}
            day={todaysAgenda || null}
            onReservationClick={() => {
              openReserveModal({
                start: parseApiDate(date),
                resourceType: ResourceType.Desk,
                office: todaysAgenda?.office_id ? authenticatedUser.offices?.byId[todaysAgenda.office_id] : null
              });
            }}
            onLocationChange={(newLocation) => {
              updateWorkingLocation(
                newLocation,
                date,
                index,
                todaysAgenda
              );
            }}
            isLocationLoading={isLoading}
            optimisticLocation={
              effectiveDay &&
              todaysAgenda &&
              effectiveDay.location !== todaysAgenda.location
                ? effectiveDay
                : effectiveDay?.office_id !== todaysAgenda.office_id
                  ? effectiveDay
                  : null
            }
          />
        );
      })}
    </div>
  );
};
